<template>
  <div class="upload-history-box">
    <div class="upload-history-dialog-content">
      <div :class="{'header':true,'header-spe':selectFile}">
        <div v-if="selectFile">
          <div class="detail-title">
            <label class="title-spe">
              <span @click="goBack">历史上传文件</span> /
            </label>
            {{ selectFile.fileOriginName }}
          </div>
          <!-- <div class="warnings">
            上传结果：成功{{ selectFile.success }}条，<span>失败{{ selectFile.fail }}条</span>
          </div> -->
          <div class="warnings warnings-tag">{{ getFileTypeStr(selectFile.type) }}</div>
        </div>
        <div v-else>
          <!-- <div>批量创建记录</div> -->
          <div>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-input
                  v-model="input"
                  clearable
                  placeholder="搜索"
                  prefix-icon="Search"
                  class="search-input"
                  @keyup.enter.native="onInputEnter"
                  @clear="onInputClear"
                />
              </el-col>
              <el-col :span="12">
                <el-date-picker
                  v-model="dateRange"
                  clearable
                  class="date-picker"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="YYYYMMDD"
                  @change="onDateChange"
                />
              </el-col>
            </el-row>
            <el-row :gutter="12" class="second-row">
              <el-col :span="8">
                <el-select v-model="declarationFormType" placeholder="报关类型" class="seleter" clearable @change="declarationFormTypeChange">
                  <el-option v-for="item in declarationTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select v-model="fileType" placeholder="模板格式" class="seleter" clearable @change="fileTypeChange">
                  <el-option v-for="item in fileTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select v-model="filterCheckedValue" placeholder="状态" class="seleter" clearable @change="filterChange">
                  <el-option v-for="item in filterOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <!-- <div class="warnings warnings-spe">上传失败为0条数据不可查看详情</div> -->
        </div>
      </div>
      <div v-if="!selectFile" class="list-content">
        <div v-for="item in files" :key="item.id" class="list-item">
          <div class="item-name">
            <div class="name-text">{{ item.fileOriginName }}</div>
            <div class="item-date">{{ item.createTime }}</div>
          </div>
          <div>
            <span class="seat-line"></span>
          </div>
          <el-row class="detail-row">
            <el-col :span="5">
              <span class="detail-sub-title">报关类型：</span>
            </el-col>
            <el-col :span="19">
              <span class="detail-sub-value">{{ getFileTypeStr(item.type) }}</span>
            </el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="5">
              <span class="detail-sub-title">数据形式：</span>
            </el-col>
            <el-col :span="9">
              <span class="detail-sub-value">{{ item.isRowData ? '数据库表格' : '报关单草单' }}</span>
            </el-col>
            <el-col :span="5">
              <span class="detail-sub-title">模板格式：</span>
            </el-col>
            <el-col :span="5">
              <span class="detail-sub-value">{{ item.isFixed ? '固定模板' : '自定义模板' }}</span>
            </el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="5">
              <span class="detail-sub-title">上传结果：</span>
            </el-col>
            <el-col :span="19">
              <span v-if="item.isFixed || item.isRowData" class="detail-sub-value">{{ `成功新增${item.ticketSuccess}票报关单，` }}</span>
              <span class="detail-sub-value">{{ `成功新增${item.success}${getUnitString(item)}，` }}</span>
              <span class="detail-sub-value">{{ `重复上传${item.repeat}${getUnitString(item)}，` }}</span>
              <span class="item-fail">{{ `异常${item.abnormal}${getUnitString(item)}` }}</span>
            </el-col>
          </el-row>
          <div class="goto-detail-text-enable" :class="{'goto-detail-text-disable': (item.abnormal===0 && item.repeat===0) || !item.logDetail}" @click="showDetail(item)">
            <a>
              查看详情
              <i class="el-icon-arrow-right"></i>
            </a>
          </div>
          <!-- <div class="item-left">
            <div class="warnings warnings-tag">{{ item.type === 'OD' ? '个人物品出口报关' : (item.type === 'OC' ? '低值商品出口报关' : '正式申报类货物(D类)出口报关') }}</div>
            <div class="item-date">
              <span class="item-success">{{ `成功${item.success}条，` }}</span><span class="item-fail">{{ `失败${item.fail}条` }}</span>
            </div>
            <div v-if="item.fail>0" :class="{'item-right': item.fail>0 && item.logDetail}" @click="showDetail(item)">查看详情 ></div>
          </div> -->
          <div v-if="!item.confirm" class="unread-info">
            <img src="@/assets/img/upload/icon-noread@2x.png" class="no-read-image" />
          </div>
        </div>
        <el-pagination class="history-pagination" layout="prev, pager, next" :page-size="10" :pager-count="5" :total="total" :current-page="currentPage" @current-change="currentChange"></el-pagination>
      </div>
      <div v-else class="detail-content">
        <div class="table-container">
          <common-table class="detail-table" :table-data="tableData" :columns="columns" :options="options" />
        </div>
        <div class="detail-footer">
          <div class="flex-info">
            <div>
              <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
              <el-button round type="primary" @click="reLoad">导出</el-button>
            </div>
            <el-pagination layout="prev, pager, next" :page-size="10" :pager-count="5" :total="detailTotal" :current-page="detailCurrentPage" @current-change="detailCurrentChange"></el-pagination>
          </div>
        </div>
      </div>
      <ResultDialog ref="resultDialogRef"></ResultDialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */ 
import CommonTable from '@/components/CommonTable/index.vue'
import variables from '@/styles/variables.module.scss'
import request from '@/request'
import download from '@/request/download'
import ResultDialog from './ResultDialog.vue'
import { declarationTypes } from '@/assets/mock-data'

export default {
    components: {
        CommonTable,
        ResultDialog
    },
    props: {
        showDrawer: {
            type: Boolean
        }
    },
    data() {
        return {
            selectFile: null,
            tableData: [],
            files: [],
            columns: [
                {
                    label: '列表行',
                    prop: 'row',
                    width: '60'
                },
                {
                    label: '运单号',
                    prop: 'trackingNumber',
                    width: '150'
                },
                {
                    label: '异常原因',
                    prop: 'desc',
                    width: '100'
                },
            ],
            options: {
                index: false,
                size: 'large',
                stripe: false,
                align: 'left',
                multipleRowSelect: false,
                commonStyle: {},
                headStyle: {
                    background: variables.rowBg
                },
                page_index: 0,
                rowStyle: this.tableRowStule,
            },
            filterOptions: [
                {
                    value: '0',
                    label: '所有'
                },
                {
                    value: '1',
                    label: '已读'
                },
                {
                    value: '2',
                    label: '未读'
                }
            ],
            filterCheckedValue: '',
            total: 0,
            currentPage: 1,
            detailTotal: 0,
            detailCurrentPage: 1,
            detailId: '',
            input: '',
            dateRange: [],
            fileType: '',
            fileTypes: [
              {
                label: '固定模板',
                value: '1'
              },
              {
                label: '自定义模板',
                value: '2'
              }
            ],
            declarationTypes: declarationTypes,
            declarationFormType: ''
        }
    },
    mounted() {
        this.show()
    },
    methods: {
      show(file) {
        this.files = [];
        this.selectFile = file;
        if(!this.selectFile) {
            // 获取历史列表
            this.httpGetHistory();
        }
      },
      showDetail(file) {
        if ((file.abnormal===0 && file.repeat===0) || !file.logDetail) return
        this.detailId = file.id
        this.getDetail()
        // this.$refs.resultDialogRef.show(this.detailId)
        // 修改日志状态
        request({
          url: '/api/v1/upload/confirm/' + file.id,
          method: 'PUT',
          hiddenLoading: true
        }).then((res) => {
        })
      },
      tableRowStule({ row, rowIndex }) {
        const background = rowIndex % 2 === 0 ? variables.menuBg : variables.rowBg
        return {
          background
        }
      },
      httpGetHistory() {
        request({
          url: `/api/v1/upload/query/log/history`,
          method: 'get',
          params: {
            pageNo: this.currentPage,
            pageSize: 10,
            confirm: this.filterCheckedValue === '1' ? true : this.filterCheckedValue === '2' ? false : '',
            beginUploadDate: this.dateRange && this.dateRange.length>0 ? this.dateRange[0] : '',
            endUploadDate: this.dateRange && this.dateRange.length>0 ? this.dateRange[1] : '',
            isFix: !this.fileType ? undefined :  this.fileType==='1',
            declarationFormType: this.declarationFormType,
            fileName: this.input
          }
        }).then( res => {
          if (res) {
            this.files = []
            res.records.forEach(item => {
              this.files.push({
                ...item,
                logDetail: (item.logDetail && item.logDetail.length>0) ? JSON.parse(item.logDetail) : null
              });
            });
            this.total = res.total
          }
        });
      },
      reLoad() {
        //this.$emit('changeShowDrawer',false)
        //this.$root.isuploadDialog = true
        download({
          url: '/api/v1/upload/download/desc',
          method: 'GET',
          params: {
            id: this.detailId
          }
        }, { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'fileType': '' }).then(res => {
        })
      },
      goBack() {
          this.selectFile = null
          this.detailTotal = 0
          this.detailCurrentPage = 1
          this.httpGetHistory()
      },
      filterChange() {
        this.httpGetHistory()
      },
      fileTypeChange(val) {
        this.httpGetHistory()
      },
      declarationFormTypeChange() {
        this.httpGetHistory()
      },
      currentChange(currentPage) {
        this.currentPage = currentPage
        this.httpGetHistory()
      },
      detailCurrentChange(currentPage) {
        this.detailCurrentPage = currentPage
        this.getDetail()
      },
      getDetail() {
          request({
              url: '/api/v1/upload/query/log/history/detail/' + this.detailId,
              method: 'GET',
              params: {
                  pageNo: this.detailCurrentPage,
                  pageSize: 10
              }
          }).then((res) => {
              this.selectFile = res
              this.getDetailTableData()
              this.detailTotal = res.total
          })
      },
      onInputEnter() {
        this.httpGetHistory()
      },
      onInputClear() {
        this.httpGetHistory()
      },
      onDateChange() {
        this.httpGetHistory()
      },
      getFileTypeStr(type) {
        if (!type || type.length === 0) return ''
        if (type === 'OB') return '个人物品申报(B类)出口报关'
        if (type === 'OC') return '低值货物快件(C类)出口报关'
        if (type === 'OD') return '正式申报类货物(D类)出口报关'
        if (type === 'IB') return '个人物品申报(B类)进口报关'
        if (type === 'IC') return '低值货物快件(C类)进口报关'
        if (type === 'ID') return '正式申报类货物(D类)进口报关'
        return ''
      },
      getDetailTableData() {
        if (!this.selectFile) return []
        if (!this.selectFile.isFixed && !this.selectFile.isRowData) {
          this.columns = [
            {
              label: '序号',
              prop: 'row',
              width: '60'
            },
            {
              label: '文件名',
              prop: 'fileName',
              width: '150'
            },
            {
              label: '异常原因',
              prop: 'desc',
              width: '100'
            }
          ]
          // 草单
          this.tableData = this.selectFile.logFileDetailList
        } else {
          this.columns = [
            {
              label: '列表行',
              prop: 'row',
              width: '60'
            },
            {
              label: '运单号',
              prop: 'trackingNumber',
              width: '150'
            },
            {
              label: '异常原因',
              prop: 'desc',
              width: '100'
            },
          ]
          this.tableData = this.selectFile.logDetailList
        }
      },
      getUnitString(item) {
        if (!item.isFixed && !item.isRowData) {
          return '个文件'
        }
        return '条'
      }
    }
}
</script>

<style lang="scss">
.upload-history-box {
  .detail-content {
    max-height: calc(100vh - 160px - 75px);
    overflow: hidden;
  }
  .el-table__body-wrapper {
    height: calc(100vh - 160px - 48px - 75px) !important;
    overflow: auto;
  }
  .el-table th, .el-table td {
    padding: 8px 0;
  }
  .el-table .cell {
    padding: 0 16px;
    color: #363636;
    font-size: 14px;
    font-weight: 400;
  }
  .el-table th>.cell {
    color: #757575;
  }
  .el-table th>.cell:last-child {
    padding-left: 5px
  }
  .history-pagination {
    position: absolute;
    bottom: 0;
    right: 24px;
  }
  .el-pagination {
    color: #5F5753;
  }
  .el-pager li.active {
    color: #0662BB;
  }
  .el-pager li {
    min-width: 28px;
  }
  .el-pagination .btn-prev {
    padding-right: 0;
  }
  .el-pagination .btn-next {
    padding-left: 0;
  }
  .el-select {
    width: 74px;
  }
  // .el-input--mini .el-input__inner, .el-select .el-input .el-select__caret {
  //     border: none;
  //     color: #0662BB;
  //     font-weight: bold;
  //     font-size: 14px;
  // }
}
.el-range-editor.el-input__wrapper {
  width: 100%;
  height: 36px;
}
.upload-history-box .el-input__wrapper {
  border: 1px solid #5F5753;
  height: 36px;
  width: 100%;
}
.upload-history-box .el-select__wrapper {
  height: 36px !important;
  border: 1px solid #5F5753;
}
</style>

<style lang="scss" scoped>

@import '@/styles/custom-dialog';

.upload-history-dialog-content {
  overflow: hidden;
}

.header {
    padding-bottom: 24px;
    color: #363636;
    font-size: 14px;
}

.header-spe {
    padding-bottom: 0;
}

.detail-title {
    padding-bottom: 12px;
}

.title-spe {
    color: #8C857F;
    cursor: pointer;
    span {
        text-decoration: underline;
    }
}

.warnings {
    font-size: 12px;
    color: #363636;
    margin-bottom: 16px;
    padding-left: 24px;
    background: url("../../../../../assets/img/customer/icon@2x.png") 0 0 no-repeat;
    background-size: 16px 16px;
    span {
        color: #DF2901;
    }
}

.warnings-spe {
    margin-top: 14px;
    margin-bottom: 0;
}

.warnings-tag {
    background: url("../../../../../assets/img/customer/tag@2x.png") 0 0 no-repeat;
    background-size: 16px 16px;
    margin-top: 8px;
}

.sub-title {
    font-size: 13px;
}

.list-content {
    height: calc(100vh - 128px - 75px - 24px);
    overflow: auto;
}

.list-item {
    border-radius: 5px;
    padding: 12px 12px;
    margin-bottom: 8px;
    background: rgba(151, 175, 208, 0.0800);
    position: relative;
}

.item-name {
    margin-top: 4px;
    display: flex;
    justify-content: space-between;

    .name-text {
        color: black;
        font-size: 16px;
        font-weight: 800;
        line-height: 20px;
        word-break: break-all;
        padding-right: 20px;
    }
}
.item-date {
    // margin-top: 10px;
    font-size: 12px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #757575;
}
.seat-line {
    width: 32px;
    height: 4px;
    background: #FFD033;
    display: inline-block;
}
.detail-row {
    margin-top: 12px;
}
.detail-sub-title {
    font-size: 13px;
    font-family: PingFang SC-中黑体, PingFang SC;
    font-weight: normal;
    color: #757575;
}
.detail-sub-value {
    font-size: 13px;
    font-family: PingFang SC-中黑体, PingFang SC;
    font-weight: bold;
    color: #363636;
}
.goto-detail-text-enable {
    margin-top: 12px;
    font-size: 16px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #0662BB;
}
.goto-detail-text-disable { 
    margin-top: 12px;
    font-size: 16px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #BFB8AF;
}
.no-read-image {
    width: 24px;
    height: 24px;
}
.item-success {
    margin-left: 12px;
}

.item-fail {
    color: #DF2901;
}

.detail-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 16px 10px 0px;
}

.flex-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.unread-info {
    width: 46px;
    height: 24px;
    font-size: 12px;
    color: #5F5753;
    border-bottom-left-radius: 30px;
    padding: 3px 0 0 14px;
    position: absolute;
    top: 0;
    right: 0;
}
.search-input {
    width: 100%;
}
.date-picker {
    width: 100%;
}
.second-row {
    margin-top: 8px;
}
.seleter {
    // margin-right: 15px;
    width: 100%;
}
</style>
